export default __webpack_public_path__ + "static/media/E09.cfb69023.mp3";